import {
  COLUMN_ACTION_WIDTH,
  COLUMN_DATE_DELETED_WIDTH,
  COLUMN_DAYS_TO_RECOVER_WIDTH,
  COLUMN_DEFAULT_WIDTH,
  COLUMN_DELETED_BY_WIDTH,
  COLUMN_TITLE_WIDTH,
  COLUMN_TYPE_WIDTH,
} from '~/components/RecentlyDeleted/constants/tableWidth';

export const getTableColumnWidth = (
  key: 'title' | 'dateDeleted' | 'deletedFrom' | 'daysToRecover' | 'deletedBy' | 'action' | 'type',
) => {
  switch (key) {
    case 'title':
      return COLUMN_TITLE_WIDTH;
    case 'dateDeleted':
      return COLUMN_DATE_DELETED_WIDTH;
    case 'deletedFrom':
      return COLUMN_DATE_DELETED_WIDTH;
    case 'daysToRecover':
      return COLUMN_DAYS_TO_RECOVER_WIDTH;
    case 'deletedBy':
      return COLUMN_DELETED_BY_WIDTH;
    case 'action':
      return COLUMN_ACTION_WIDTH;
    case 'type':
      return COLUMN_TYPE_WIDTH;
    default:
      return COLUMN_DEFAULT_WIDTH;
  }
};
